import React from "react";

const RoleBindingsTable = ({ bindings }) => {
  const maxCount = Math.max(...bindings.map((b) => b.count || 0));

  return (
    <div className="p-4 mt-6 bg-white rounded-lg shadow">
      <h2 className="mb-4 text-lg font-semibold">Role Bindings Overview</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left rounded-l-lg">Binding Name</th>
              <th className="px-4 py-2 text-left">Count</th>
              <th className="px-4 py-2 text-left">Type</th>
              <th className="px-4 py-2 text-left rounded-r-lg">Action</th>
            </tr>
          </thead>
          <tbody>
            {bindings.map((binding, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-3">{binding.bindingName}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center w-40 gap-2">
                    <div className="w-full h-3 bg-gray-200 rounded">
                      <div
                        className="h-3 bg-blue-500 rounded"
                        style={{
                          width: `${(binding.count / maxCount) * 100}%`,
                        }}
                      ></div>
                    </div>
                    <span className="text-xs text-gray-600">
                      ({binding.count})
                    </span>
                  </div>
                </td>
                <td className="px-4 py-3">{binding.type}</td>
                <td className="px-4 py-3">
                  <button className="px-3 py-1 text-white bg-red-500 rounded hover:bg-red-600">
                    Detach
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoleBindingsTable;
